/**
 * @file The Component contains the whole Configuration information for user to review their choices
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import React from 'react';
import { Button, Row, Col, Icon, Form } from 'antd';

//data & funcs
import { generateLinuxFile } from '../../../../FileGenerator/FileGenerator';
import { generateSummary, triggerLambda } from '../../../../Utils/utils';
import {
    summaryStructure,
    state2PrefixMap,
    state2CommentMap,
} from '../../../../Utils/LinuxDataLoader';
import {
    M11_4_12,
    M11_5_03,
    M11_5_06,
    M11_5_09,
    M11_5_12,
    M11_6_03,
    M11_6_06,
    M11_6_09,
} from '../../../../Utils/Constants';
//components
import Navigation from '../../../Navigation/Navigation';
//css
import 'antd/dist/antd.css';
import '../../../../Utils/CommonCss.css';

class Summary extends React.Component {
    backStep = () => {
        this.props.backStep();
    };

    /**
     * To generate the Option.txt and download it locally
     */
    downloadTxtFile = () => {
        const element = document.createElement('a');
        let res = generateLinuxFile(
            this.props,
            state2PrefixMap,
            state2CommentMap
        );

        let fileName;
        switch (this.props.useVersion) {
            case M11_4_12:
                fileName = 'options_m11_4_12.txt';                
                break;
            case M11_5_03:
                fileName = 'options_m11_5_03.txt';                
                break;
            case M11_5_06:
                fileName = 'options_m11_5_06.txt';
                break;
            case M11_5_09:
                fileName = 'options_m11_5_09.txt';
                break;
            case M11_5_12:
                fileName = 'options_m11_5_12.txt';
                break;
            case M11_6_03:
                fileName = 'options_m11_6_03.txt';
                break;
            case M11_6_06:
                fileName = 'options_m11_6_06.txt';
                break;
            case M11_6_09:
                fileName = 'options_m11_6_09.txt';
                break;
            default:
        }

        let file = new File([res], fileName, {
            type: 'text/plain',
        });

        element.href = URL.createObjectURL(file);
        element.download = file.name;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();

        let info = {
            fileName: file.name,
            companyName: this.props.getOriginState('userRegistrationCompany'),
            os: this.props.useOs,
            mode: this.props.useMode,
            version: this.props.useVersion,
        };

        triggerLambda(
            info,
            function (response) {
                console.log('Success!');
            },
            function (error) {
                console.error(error);
            }
        );
    };

    render() {
        return (
            <Form className="form">
                <Row type="flex" align="top">
                    <Col
                        span={4}
                        className={['colNav', 'linSummaryNavHeight'].join(' ')}
                    >
                        <p className="headlineTop">Steps</p>
                        <Navigation
                            setOriginState={this.props.setOriginState}
                            getOriginState={this.props.getOriginState}
                            steps={this.props.steps}
                            deepestStep={this.props.deepestStep}
                            useOs={this.props.useOs}
                        />
                    </Col>

                    <Col span={18} className="colContent">
                        <p className="headlineTop">Summary</p>
                        <div className="summaryContainer">
                            {generateSummary(summaryStructure, this.props)}
                        </div>
                    </Col>
                </Row>
                <div className="buttonBar">
                    <div className="description">
                        You are creating a configuration file for
                        <img
                            src={require('../../../../assets/Icons/Linux.png')}
                            alt="Operating System"
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            className="buttonBack"
                            type="default"
                            onClick={this.backStep}
                        >
                            Back
                        </Button>
                        <Button
                            className="buttonNext"
                            type="primary"
                            onClick={this.downloadTxtFile}
                        >
                            <Icon type="vertical-align-bottom" />
                            Download File
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

export default Summary;
